import { render } from "./NodeDocs.vue?vue&type=template&id=207333d2&ts=true"
import script from "./NodeDocs.vue?vue&type=script&lang=ts"
export * from "./NodeDocs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__